import { Container } from 'inversify'
import { ErrorPlatformEvent, interpret } from 'xstate'
import { rootContainer } from '~/container'
import sentryCapture from '~/utility/sentryCapture'
import { CurrenciesRepository, CurrencyRate } from './domain'
import { AjaxCurrencyRepository } from './infrastructure/AjaxCurrencyRepository'
import {
  CurrenciesMachineInterpreter,
  returnCurrenciesStateMachine,
} from './machine'

// tslint:disable-next-line variable-name
export const ICurrenciesMachine = Symbol('CurrenciesMachine')

export const currenciesContainer = new Container()
currenciesContainer.parent = rootContainer
currenciesContainer.bind(CurrenciesRepository).to(AjaxCurrencyRepository)
currenciesContainer
  .bind<CurrenciesMachineInterpreter>(ICurrenciesMachine)
  .toDynamicValue(({ container }) =>
    interpret(
      returnCurrenciesStateMachine().withConfig({
        services: {
          fetchCurrencyRates: () =>
            container.get(CurrenciesRepository).readAll(),
        },
        actions: {
          logError: (_, _event: any) => {
            const event: ErrorPlatformEvent = _event
            event.data.name = 'currenciesStateMachine ' + event.type + ' error'
            sentryCapture(event.data, rootContainer)
          },
        },
      }),
    ).start(),
  )
  .inSingletonScope()

export type CurrencyRecords = Record<string, CurrencyRate>
export type CurrenciesProvider = () => Promise<CurrencyRecords>
// tslint:disable-next-line variable-name
export const ICurrenciesProvider = Symbol('CurrenciesProvider')
currenciesContainer
  .bind<CurrenciesProvider>(ICurrenciesProvider)
  .toProvider<CurrencyRecords>(({ container }) => {
  return () => {
    return new Promise<CurrencyRecords>((resolve, reject) => {
      const machine =
          container.get<CurrenciesMachineInterpreter>(ICurrenciesMachine)
      handlePromise(machine, resolve, reject)
      machine.onDone(() => {
        handlePromise(machine, resolve, reject)
      })
    })
  }
})

function handlePromise(machine: CurrenciesMachineInterpreter, resolve, reject) {
  if (machine.state.matches('success')) {
    resolve(machine.state.context.currencies)
  } else if (machine.state.matches('error')) {
    reject()
  }
}
